import Vue from 'vue'
import App from './App.vue'
// import 'lib-flexible'
import router from './router'
import store from './store'
import axios from 'axios'
import utils from './utils/urlGet'
import http from './utils/config'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import $ from 'jquery'
import VueCookies from 'vue-cookies'
import CryptoJS from 'crypto-js'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'

Vue.use(ElementUI, {
  locale
})


import {Button} from 'vant';

Vue.use(Button);

import layer from 'vue-layer'
import ScreentipsMask from './components/common/ScreenTips.vue'
import 'mint-ui/lib/style.css'
import {
  Picker
} from 'mint-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import {
  DropdownMenu,
  DropdownItem
} from 'vant';
import {
  Popup
} from 'mint-ui';
import {
  Toast
} from 'mint-ui';
import {
  Actionsheet
} from 'mint-ui';
import {
  DatetimePicker
} from 'mint-ui';
import {
  MessageBox
} from 'mint-ui';
import 'vue-layer/lib/vue-layer.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'swiper/css/swiper.css'
import 'animate.css'
import '@Assets/fonts/iconfont.css'
import '@Assets/css/animate.css'
import '../assets/css/common.css'
import './assets/styles/common.css'

require("./assets/styles_m/mMedia.css");
require("./assets/styles_m/reset.css");
require("./assets/styles_m/border.css");
require("./assets/js_m/rem.js");

import FBSignInButton from 'vue-facebook-signin-button'
import VueBus from 'vue-bus'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueBus)
Vue.use(VueClipboard)
Vue.use(FBSignInButton)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(VueCookies)
Vue.component(DatetimePicker.name, DatetimePicker);
Vue.component(Picker.name, Picker);
Vue.use(Vant);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.component(Toast);
Vue.component(Popup.name, Popup);
Vue.component(Actionsheet.name, Actionsheet);
Vue.prototype.$layer = layer(Vue)
Vue.prototype.CryptoJS = CryptoJS
Vue.prototype.$utils = utils
//全局使用，挂载到原型上
Vue.prototype.$messagebox = MessageBox

/* axios配置 */
Vue.prototype.$http = axios;
Vue.prototype.$axios = http;
var querystring = require('querystring');

// 正式服
var baseUrl = "https://api.hermesgames.com.tw";
// 测试服
// var baseUrl = "http://testick.api.iclockwork.com"

/*
 * 封装ajax
 * obj : 全局this
 * data : ajax传入后台data数据
 * address : ajax接口地址
 * fn : 成功返回方法  带参数  obj,data  obj:this, data:response
 * */
Vue.prototype.postHttp = function (obj, data, address, fn) {
  http.post(baseUrl + address, data).then(response => {
    fn(obj, response);
  }, response => {

  })
}
Vue.prototype.getHttp = function (obj, data, address, fn) {
  http.get(baseUrl + address, {
    params: data
  }).then(function (response) {
    fn(obj, response)
  }).catch(function (response) {

  });
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * 横竖屏切换
 */
window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function () {
  if (window.orientation === 180 || window.orientation === 0) {
    store.commit('setIsMaskScreenTips', false);
  }
  if (window.orientation === 90 || window.orientation === -90) {
    store.commit('setIsMaskScreenTips', true);
  }
}, false);

// 页面进入后再进行终端判断跳转总共四个链接
// setTimeout(() => {
// 	requireParams();
// }, 1000)

/**
 * 截取地址栏参数,调取第三方登录接口
 */
// function requireParams() {
// 	let account = Vue.prototype.$utils.getUrlKey("account");
// 	let name = Vue.prototype.$utils.getUrlKey("name");
// 	let token = Vue.prototype.$utils.getUrlKey("token");
// 	let type = Vue.prototype.$utils.getUrlKey("type");
// 	let signature = Vue.prototype.$utils.getUrlKey("signature");
// 	console.log("414传来的canshu",'account:', account, 'name:', name,'token:', token,'type:', type, 'signature',signature);
// 	if (account && name && token && type) {
// 		let datas = {
// 			account: account,
// 			name: name,
// 			token: token,
// 			type: type,
// 		};
// 		Vue.prototype.postHttp(this, datas, "/front/others/login", function (
// 			obj,
// 			data
// 		) {
// 			if (data.status == "2000") {
// 				store.commit('setIsHmsLogin', false);
// 				let token = data.data.bear_token;
// 				let userInfo = data.data.user_info;
// 				store.commit("setToken", token);
// 				store.commit("setUserInfo", userInfo);
// 				localStorage.setItem("token", token);
// 				localStorage.setItem(
// 					"userInfo",
// 					JSON.stringify(userInfo)
// 				);
// 			} else {
// 			}
// 			Toast(data.message);
// 		});
// 	} else {}
// }
